<template>
  <div class="doctorConfig big">
    <div class="page_title">医生端活动配置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item index="1" style="font-size: 16px"
              >首页Banner</el-menu-item
            >
            <el-menu-item index="2" style="font-size: 16px"
              >首页弹窗</el-menu-item
            >
            <el-menu-item
              index="3"
              style="font-size: 16px"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1827') : false
              "
              >医生活动页配置</el-menu-item
            >
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <component :is="currentComponent" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HomeBanner from "./HomeBanner.vue";
import HomeDia from "./HomeDia.vue";
import DoctorActivity from "./DoctorActivity.vue";
export default {
  data() {
    return {
      activeIndex: "1",
      active: "1",
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
    currentComponent() {
      switch (this.active) {
        case "1":
          return HomeBanner;
        case "2":
          return HomeDia;
        case "3":
          return DoctorActivity;
        default:
          return HomeBanner;
      }
    },
  },
  created() {},
  methods: {
    handleSelect(key) {
      this.active = key;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>